import { Description } from '@mui/icons-material'
import { Button } from '@mui/material'
import { useFormikContext } from 'formik'
import React, { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react'
import { useAppTranslations } from '../../utils/hooks/useAppTranslations'

const FileInputField: React.FC<{
  name: string
  accept: string
  onFileChange?: (event: ChangeEvent<HTMLInputElement>) => void
}> = ({ name, accept, onFileChange }): JSX.Element => {
  const t = useAppTranslations()
  const { initialValues, setFieldValue } = useFormikContext()
  const [fileName, setFileName] = useState('')
  const inputRef = useRef<HTMLInputElement | null>(null)
  const setFieldValueRef = useRef(setFieldValue)
  setFieldValueRef.current = setFieldValue

  useEffect(() => {
    setFileName('')
  }, [initialValues])

  const openFilePicker = useCallback((): void => {
    inputRef.current?.click()
  }, [])

  const onFileUpload = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      let filename = ''
      if (event?.target?.files?.length) {
        filename = event.target.files[0].name
        !onFileChange && setFieldValueRef.current(name, event.target.files[0])
      }
      setFileName(filename)
      onFileChange && onFileChange(event)

      event.target.value = ''
    },
    [name, onFileChange]
  )

  return (
    <>
      <Button
        variant="outlined"
        type="button"
        color={fileName ? 'primary' : 'secondary'}
        sx={{ my: '0.5rem' }}
        onClick={openFilePicker}
      >
        {fileName ? (
          <>
            <Description sx={{ mr: 2 }} /> {fileName}
          </>
        ) : (
          t('commons.actions.selectFile')
        )}
      </Button>
      <input ref={inputRef} name={name} accept={accept} hidden multiple type="file" onChange={onFileUpload} />
    </>
  )
}

export default FileInputField
